var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import DragAndDropHelper from 'mixins/DragAndDropHelper';
import ActivityStage from 'components/activity/ActivityStage.vue';
import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';
import CorrectIcon from 'components/icons/SuccessCheckSolidIcon.vue';
import DynamicContent from '../components/activity/DynamicContent.vue';
import HtmlRenderer from 'components/activity/HtmlRenderer.vue';
import NextActivityButton from 'components/activity/NextActivityButton.vue';
import TextDisplayList from 'components/text-displays/TextDisplayList.vue';
import WrongIcon from 'components/icons/RedXSolidIcon.vue';
import ActivityWrapper from '../components/activity/ActivityWrapper.vue';
import mixins from 'vue-typed-mixins';
const CORRECT_BORDER_COLOR = '#2A7536';
const INCORRECT_BORDER_COLOR = '#A90606';
export default mixins(DragAndDropHelper()).extend({
    name: 'DragAndDropCategories',
    components: {
        ActivityStage,
        ActivityWrapper,
        BlinkingCursorText,
        CorrectIcon,
        DynamicContent,
        HtmlRenderer,
        NextActivityButton,
        TextDisplayList,
        WrongIcon
    },
    data() {
        return {
            selectedElement: null
        };
    },
    mounted() {
        window.addEventListener('resize', this.recalibrateAnswersOnResize);
        setTimeout(() => {
            this.setCategoryAriaLabels();
        }, 500);
    },
    destroyed() {
        window.removeEventListener('resize', this.recalibrateAnswersOnResize);
    },
    computed: {
        hasGuessedAllAnswers() {
            return this.correctGuesses.length === this.currentRound.draggableItems.length;
        },
        imageHeight() {
            var _a, _b;
            const numOfDraggableItems = this.currentRound.draggableItems.length;
            const numOfFixedItems = (_b = (_a = this.currentRound.dropZones) === null || _a === void 0 ? void 0 : _a.reduce((acc, curr) => {
                var _a, _b;
                return acc + ((_b = (_a = curr.fixedItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
            }, 0)) !== null && _b !== void 0 ? _b : 0;
            const totalShapes = numOfDraggableItems + numOfFixedItems;
            const draggableHeight = Math.floor(120 / totalShapes);
            return {
                drag: `${Math.floor(draggableHeight / 2)}%`,
                drop: `${draggableHeight}%`
            };
        }
    },
    watch: {
        guessed() {
            this.setCategoryAriaLabels();
        },
        correctGuesses() {
            this.setCategoryAriaLabels();
        }
    },
    methods: {
        // start activity helper methods
        getKeyboardConfig() {
            return this.getKeyboardConfigHelper();
        },
        loadActivity() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loadActivityHelper();
            });
        },
        loadAudios(activityAudios) {
            return __awaiter(this, void 0, void 0, function* () {
                return this.loadAudiosHelper(activityAudios);
            });
        },
        startActivity() {
            this.setRoundHelper();
            this.$nextTick(() => {
                this.setActivityContainerHeight();
            });
        },
        // end activity helper methods
        // start activity specific methods
        addToGuessedArray(closestDropZone, draggableItem) {
            const { id: dropZoneElId } = closestDropZone;
            const dropAreaId = dropZoneElId.split('-')[1];
            const droppableItem = this.getAssociatedDroppableItem(dropAreaId);
            const guessedArr = [...this.guessed].filter(guessed => guessed.draggableItem !== draggableItem);
            this.guessed = _.uniq([...guessedArr, { draggableItem, droppableItem }]);
        },
        checkIfCloseToDropZone(x, y, target) {
            const { height, width } = target.getBoundingClientRect();
            const closestDropZone = this.findClosestDropArea({
                x,
                y,
                height,
                width
            });
            if (!closestDropZone)
                return;
            const closetDropZoneId = JSON.parse(closestDropZone.id.split('-')[1]);
            this.closestDropZoneId = closetDropZoneId;
            if (closetDropZoneId === this.correctDropAreaId) {
                this.hintBorderColor = CORRECT_BORDER_COLOR;
                return;
            }
            this.hintBorderColor = INCORRECT_BORDER_COLOR;
        },
        findClosestDropArea(dragItemCoordinates) {
            const allDroppableAreas = this.getAllDroppableAreas();
            let closestDropZone;
            const { x: dragX, y: dragY, height: dragHeight, width: dragWidth } = dragItemCoordinates;
            const halfDragHeight = dragHeight / 2;
            const halfDragWidth = dragWidth / 2;
            allDroppableAreas.find((droppableArea, index) => {
                const { left: dropLeft, right: dropRight, top: dropTop, bottom: dropBottom } = droppableArea.position;
                const isXInTarget = dragX >= dropLeft - halfDragWidth && dragX <= dropRight - halfDragWidth;
                const isYInTarget = dragY >= dropTop - halfDragHeight && dragY <= dropBottom - halfDragHeight;
                if (isXInTarget && isYInTarget) {
                    closestDropZone = droppableArea;
                }
            });
            return closestDropZone;
        },
        getCategoryBorder(droppableItem) {
            const numOfCorrectDropZoneGuesses = this.correctGuesses.filter(guess => guess.droppableItem === droppableItem).length;
            const isCorrect = numOfCorrectDropZoneGuesses === droppableItem.correctItemIds.length;
            let borderColor = !this.isSubmitted
                ? 'black'
                : isCorrect
                    ? CORRECT_BORDER_COLOR
                    : INCORRECT_BORDER_COLOR;
            let borderWidth = '2px';
            if (this.shouldShowHint &&
                this.hintBorderColor &&
                droppableItem.id === this.closestDropZoneId) {
                borderColor = this.hintBorderColor;
                borderWidth = '5px';
            }
            return {
                border: `${borderWidth} solid ${borderColor}`,
                borderRadius: '8px'
            };
        },
        getIsCorrect(guessedAnswer) {
            return guessedAnswer.droppableItem.correctItemIds.includes(guessedAnswer.draggableItem.id);
        },
        handleDrop(context, dropZone = null) {
            const { target } = context;
            const draggableId = target.getAttribute('data-id');
            const draggableItem = this.getAssociatedDraggableItem(draggableId);
            if (!draggableItem)
                return;
            this.removeFromGuessed(draggableItem);
            this.hintBorderColor = '';
            const dragItemCoordinates = target.getBoundingClientRect();
            let closestDropZone = this.findClosestDropArea(dragItemCoordinates);
            if (dropZone) {
                closestDropZone = {
                    id: `dropArea-${dropZone.id}`,
                    position: dropZone.getBoundingClientRect()
                };
                this.handleMoveDragItemToDropArea(closestDropZone);
            }
            if (closestDropZone) {
                this.addToGuessedArray(closestDropZone, draggableItem);
                return;
            }
            this.resetDraggable(target);
            this.removeFromGuessed(draggableItem);
        },
        getDropZonePosition(closestDropZone, element) {
            var _a;
            if (!element)
                return {};
            const originalDraggablePos = (_a = document
                .getElementById(`startingPoint-${element.getAttribute('data-id')}`)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!originalDraggablePos)
                return {};
            const { position: closestDropZonePos } = closestDropZone;
            const xPos = closestDropZonePos.x - originalDraggablePos.x + 100 * (this.guessed.length + 1);
            const yPos = closestDropZonePos.y -
                originalDraggablePos.y -
                (originalDraggablePos.height - closestDropZonePos.height) / 2;
            return { xPos, yPos };
        },
        handleMoveDragItemToDropArea(dropArea) {
            const { xPos, yPos } = this.getDropZonePosition(dropArea, this.selectedElement);
            this.moveDraggableToDropZone(this.selectedElement, xPos, yPos);
            this.selectedElement = null;
        },
        isElementSelected(item) {
            if (this.selectedElement) {
                return this.selectedElement.id === `draggable-${item.id}`;
            }
        },
        isGuessed(draggableItem) {
            if (!draggableItem)
                return false;
            return [...this.guessed, ...this.correctGuesses].some(item => item.draggableItem.id === draggableItem.id);
        },
        isGuessedCorrectly(draggableItem) {
            if (!draggableItem)
                return false;
            return this.correctGuesses.some(item => item.draggableItem.id === draggableItem.id);
        },
        isGuessedIncorrectly(droppableItem) {
            if (!droppableItem)
                return false;
            return this.wrongGuesses.some(item => item.droppableItem.id === droppableItem.id);
        },
        shouldShowIcon(droppableItem, isCorrectIcon) {
            const numOfCorrectDropZoneGuesses = this.correctGuesses.filter(guess => guess.droppableItem === droppableItem).length;
            const isDropZoneCorrect = numOfCorrectDropZoneGuesses === droppableItem.correctItemIds.length;
            const shouldShowIcon = isCorrectIcon ? isDropZoneCorrect : !isDropZoneCorrect;
            const isShowingHint = this.shouldShowHint && this.hintBorderColor && droppableItem.id === this.closestDropZoneId;
            const shouldShowHintIcon = isCorrectIcon
                ? this.hintBorderColor === CORRECT_BORDER_COLOR
                : this.hintBorderColor === INCORRECT_BORDER_COLOR;
            return (shouldShowIcon && this.isSubmitted) || (shouldShowHintIcon && isShowingHint);
        },
        // start of accessibility methods
        getShapeDescriptions(arr) {
            return arr.reduce((acc, curr, index) => {
                var _a, _b, _c;
                const text = !index
                    ? (_b = (_a = curr.image) === null || _a === void 0 ? void 0 : _a.image.description) !== null && _b !== void 0 ? _b : ''
                    : ` And ${(_c = curr.image) === null || _c === void 0 ? void 0 : _c.image.description}`;
                acc = acc.concat(text);
                return acc;
            }, '');
        },
        getDragAreaAriaLabel() {
            var _a, _b;
            const allGuessesIds = [...this.guessed, ...this.correctGuesses].map(g => g.draggableItem.id);
            const unguessed = (_b = ((_a = this.currentRound.draggableItems) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.filter(item => !allGuessesIds.includes(item.id));
            if (unguessed === null || unguessed === void 0 ? void 0 : unguessed.length) {
                const shapeDescriptions = this.getShapeDescriptions(unguessed);
                return `Bank area with ${shapeDescriptions}`;
            }
            return 'Empty bank area.';
        },
        setCategoryAriaLabels() {
            var _a;
            (_a = this.currentRound.dropZones) === null || _a === void 0 ? void 0 : _a.map(item => {
                const dropzone = document.getElementById(`dropArea-${item.id}`);
                if (!dropzone)
                    return;
                const label = this.getCategoryAriaLabel(item.id);
                if (!label)
                    return;
                dropzone.ariaLabel = label;
            });
        },
        getCategoryAriaLabel(id) {
            const titleNode = document.getElementById(`titleText-${id}`);
            const title = titleNode === null || titleNode === void 0 ? void 0 : titleNode.innerText;
            const allGuesses = [...this.guessed, ...this.correctGuesses];
            const categoryGuesses = allGuesses.filter(guess => guess.droppableItem.id === id);
            if (categoryGuesses === null || categoryGuesses === void 0 ? void 0 : categoryGuesses.length) {
                const shapeDescriptions = this.getShapeDescriptions(categoryGuesses.map(g => g.draggableItem));
                return `${title} Area with guesses: ${shapeDescriptions}`;
            }
            return `${title} Area`;
        },
        recalibrateAnswersOnResize() {
            if (!this.guessed.length)
                return;
            this.guessed.forEach(({ draggableItem, droppableItem }) => {
                var _a;
                const closestDropZone = (_a = this.getAllDroppableAreas()) === null || _a === void 0 ? void 0 : _a.find(({ id }) => id === `dropArea-${droppableItem.id}`);
                const target = document.getElementById(`draggable-${draggableItem.id}`);
                const { xPos, yPos } = this.getDropZonePosition(closestDropZone, target);
                this.moveDraggableToDropZone(target, xPos, yPos);
            });
        }
        // end of accessibility methods
    }
});
